module.exports = __webpack_public_path__ + "img/login_logo.651f9908.png";